<template>
  <div class="wizard-step-sucesso">
    <div class="text-center text-success" style="padding-top: 30px">
      <i class="pi pi-check success-icon"></i>
      <h3>{{ t('Sucesso! Serviço finalizado corretamente') }}.</h3>
      <p class="success-message">{{ t('O wizard será fechado automaticamente') }}...</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { eventBus } from '../../../eventBus';
import { log } from '../../../utils/DebugLogger';

const { t } = useI18n();

const emit = defineEmits<{
  'close': [];
}>();

// Tracked so the unmount cancels it: if the wizard is closed inside the 3 s
// window, an untracked timer still emits the global completion event from a
// component that no longer exists.
let autoCloseTimer: ReturnType<typeof setTimeout> | null = null;

// Methods
const autoClose = () => {
  log('WizardStep4Sucesso', 'autoClose', 'Auto-closing wizard after delay');

  // Close after 3 seconds
  autoCloseTimer = setTimeout(() => {
    log('WizardStep4Sucesso', 'autoClose', 'Closing wizard and emitting completion event');

    // Emit completion event
    eventBus.emit('wizard-servicos.completed');

    // Emit close to parent
    emit('close');
  }, 3000);
};

// Lifecycle
onMounted(() => {
  log('WizardStep4Sucesso', 'mounted', 'Success step mounted');
  autoClose();
});

onUnmounted(() => {
  if (autoCloseTimer) clearTimeout(autoCloseTimer);
  autoCloseTimer = null;
});
</script>

<style scoped>
.wizard-step-sucesso {
  padding: 60px 20px;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.success-icon {
  font-size: 80px;
  margin-bottom: 30px;
  color: #00a65a;
  animation: scaleIn 0.5s ease-out;
}

h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  animation: fadeIn 0.8s ease-out;
}

.success-message {
  font-size: 16px;
  color: #666;
  animation: fadeIn 1.2s ease-out;
}

.text-success {
  color: #00a65a;
}

/* Animations */
@keyframes scaleIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .success-icon {
    font-size: 60px !important;
  }

  h3 {
    font-size: 20px;
  }

  .success-message {
    font-size: 14px;
  }
}
</style>
